/* NEKOVIBE — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nk-reveal:not(.nk-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nk-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('nk-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initCuentas(root) {
    (root || document).querySelectorAll('[data-nk-cuenta]').forEach(function (el) {
      if (el._nkTimer) clearInterval(el._nkTimer);
      var mes = parseInt(el.getAttribute('data-mes'), 10) - 1;
      var dia = parseInt(el.getAttribute('data-dia'), 10);
      function objetivo() {
        var ahora = new Date();
        var t = new Date(ahora.getFullYear(), mes, dia, 0, 0, 0);
        if (t - ahora < -86400000) t = new Date(ahora.getFullYear() + 1, mes, dia);
        return t;
      }
      var meta = objetivo();
      var campos = {
        d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
        m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]')
      };
      function pinta() {
        var diff = Math.max(0, meta - new Date());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        if (campos.d) campos.d.textContent = d;
        if (campos.h) campos.h.textContent = String(h).padStart(2, '0');
        if (campos.m) campos.m.textContent = String(m).padStart(2, '0');
        if (campos.s) campos.s.textContent = String(s).padStart(2, '0');
      }
      pinta();
      el._nkTimer = setInterval(pinta, 1000);
    });
  }

  function formatoDinero(cents, formato) {
    var valor = (cents / 100).toFixed(2);
    var partes = valor.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conComa = miles + ',' + partes[1];
    var sinDec = miles;
    formato = formato || '{{amount}} €';
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return conComa;
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return sinDec;
      return (cents / 100).toFixed(2);
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-nk-producto]').forEach(function (wrap) {
      // Galería
      var principal = wrap.querySelector('[data-nk-principal]');
      wrap.querySelectorAll('[data-nk-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 180);
          wrap.querySelectorAll('[data-nk-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });

      // Cantidad
      var qty = wrap.querySelector('[data-nk-qty]');
      wrap.querySelectorAll('[data-nk-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-nk-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var datos = wrap.querySelector('[data-nk-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = wrap.getAttribute('data-money-format');
      var idInput = wrap.querySelector('input[name="id"]');
      var boton = wrap.querySelector('[data-nk-add]');
      var precio = wrap.querySelector('[data-nk-precio]');
      var antes = wrap.querySelector('[data-nk-antes]');
      var ahorro = wrap.querySelector('[data-nk-ahorro]');
      var txtAdd = boton ? boton.getAttribute('data-txt-add') : '';
      var txtAgotado = boton ? boton.getAttribute('data-txt-agotado') : '';

      function actualiza() {
        var elegidas = [];
        wrap.querySelectorAll('[data-nk-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txtAgotado; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = formatoDinero(v.price, formato);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = formatoDinero(v.compare_at_price, formato); antes.hidden = false;
            if (ahorro) { ahorro.hidden = false; ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { antes.hidden = true; if (ahorro) ahorro.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? txtAdd : txtAgotado;
        }
        if (v.featured_image && principal) { principal.src = v.featured_image.src; principal.srcset = ''; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      wrap.querySelectorAll('[data-nk-opcion] input').forEach(function (i) { i.addEventListener('change', actualiza); });
    });
  }

  function initTodo(root) { initReveal(root); initCuentas(root); initProducto(root); }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
